<script>
import { mapActions, mapState, mapGetters } from "vuex";
import Favicon from "../components/icon/favicon.vue";
import MadeWith from "../components/MadeWith.vue";
import Spinner from "../components/Spinner.vue";
import Status from "../components/Modales/Status.vue";
import BotonesSso from "@/components/Login/BotonesSso.vue";
import { borrarMarcaSesion, marcarSesionNavegador } from "@/utils/sesion";
import { mensajeErrorSso } from "@/utils/sso/errores";
import { iniciarSsoGoogle, leerRetornoSso } from "@/utils/sso/redireccion";
export default {
  components: { Spinner, Status, MadeWith, Favicon, BotonesSso },
  data() {
    return {
      view: "login",
      email: "",
      password: "",
      verPassword: false,
      login_type: null,
      valid_mail: false,
      incorrect_mail: false,
      error_pass_mail: false,
      login_error_msg: "Correo o contraseña inválidas",
      // El error del SSO va aparte del de contraseña: se muestra bajo sus
      // botones, para que quede claro cuál de los dos ingresos falló
      sso_error_msg: "",
      procesandoSso: false,
      recordarSesion: false,
      show_spinner: false,
      recoveryEmail: "",
      recoveryEmailError: "",
      recoveryStatus: null,
      recoveryMsg: "",
      show_spinner_recover: false,
      publicPath: process.env.BASE_URL,
      pageReady: false,
    };
  },

  computed: {
    ...mapState("sidebar", ["modules"]),
    ...mapGetters("sidebar", ["userHasInicio"]),
  },

  watch: {
    email: function () {
      setTimeout(() => {
        this.validLoginInput(this.email);
      }, 2000);
    },
    view: function (newView) {
      if (newView === "login") {
        this.sso_error_msg = "";
        this.recoveryEmail = "";
        this.recoveryEmailError = "";
        this.recoveryStatus = null;
        this.recoveryMsg = "";
        this.show_spinner_recover = false;
      }
    },
  },

  created() {
    // Si ya hay sesión, quien redirige es el guard `beforeEach` del router: él
    // mira el access-token, que es la sesión de verdad. Antes esto también
    // redirigía mirando sólo el usuario en localStorage, y las dos
    // redirecciones se pisaban ("Navigation cancelled ... with a new
    // navigation"); además, con usuario pero sin token mandaba a una ruta
    // protegida que el guard devolvía a Login.
    this.checkSessionExpiration();
    // Vuelta desde Google: se lee aquí, lo antes posible, porque leerRetornoSso
    // además borra los tokens de la URL
    this.completarRetornoSso(leerRetornoSso());
  },

  mounted() {
    this.validLoginInput(this.email);
    this.$nextTick(() => {
      setTimeout(() => {
        this.pageReady = true;
      }, 60);
    });
  },

  methods: {
    ...mapActions("sidebar", ["getModules"]),
    ...mapActions("loginModule", [
      "getUserDataFromTokenAction",
      "loginAdmin",
      "recoverPasswordAction",
      "getAuthTokens",
    ]),

    goToRecoverView() {
      this.view = "recover";
    },

    goToLoginView() {
      this.view = "login";
    },

    closeRecoveryStatus() {
      this.recoveryStatus = null;
    },

    validateRecoveryEmail() {
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.recoveryEmail || this.recoveryEmail.trim() === "") {
        this.recoveryEmailError = "Campo requerido.";
        return false;
      }
      if (!String(this.recoveryEmail).toLowerCase().match(emailRegex)) {
        this.recoveryEmailError = "El correo no está bien formado.";
        return false;
      }
      this.recoveryEmailError = "";
      return true;
    },

    async onPassRecoverySubmit() {
      if (!this.validateRecoveryEmail()) return;
      this.show_spinner_recover = true;
      await this.passwordRecovery();
      this.show_spinner_recover = false;
    },

    async passwordRecovery() {
      const payload = {
        correo: this.recoveryEmail,
      };
      const resp = await this.recoverPasswordAction(payload);
      this.recoveryStatus = true;
      if (resp && resp.action === "success") {
        this.recoveryStatus = true;
        this.recoveryMsg =
          "Se ha enviado un correo a la dirección que ingresaste. Por favor sigue las instrucciones para restablecer la contraseña.";
      } else {
        this.recoveryStatus = false;
        this.recoveryMsg =
          "Hubo un error en el envío del correo. Por favor intenta nuevamente.";
      }
    },

    showLoginError(msg) {
      this.login_error_msg = msg;
      this.error_pass_mail = true;
    },

    clearSession() {
      localStorage.removeItem("access-token");
      this.$ls.remove("user");
      this.$ls.remove("user_empresa");
      this.$ls.remove("remember_session");
      borrarMarcaSesion();
    },

    async logIn() {
      this.validLoginInput(this.email);
      if (
        this.email.length <= 5 ||
        this.password.length <= 3 ||
        this.login_type === null
      ) {
        return;
      }

      this.show_spinner = true;
      this.error_pass_mail = false;
      this.sso_error_msg = "";
      const b64_pass = btoa(btoa(btoa(this.password)));

      const payload = {
        login: this.email,
        password: b64_pass,
        tipo_login: this.login_type,
        plataforma: "2",
        tipo_web: "1" /* 1: administrador, 2: intranet */,
      };

      try {
        // getAuthTokens devuelve null tanto si las credenciales son inválidas
        // como si el backend responde con error (p.ej. "Error: 404").
        const respAuthTokens = await this.getAuthTokens(payload);
        if (!respAuthTokens || !respAuthTokens.access_token) {
          this.showLoginError("Correo o contraseña inválidas");
          return;
        }

        const error = await this.completarInicioSesion(respAuthTokens);
        if (error) this.showLoginError(error);
      } catch (e) {
        console.error("Error en el inicio de sesión:", e);
        this.clearSession();
        this.showLoginError(
          "No pudimos iniciar sesión. Por favor intenta nuevamente en unos minutos.",
        );
      } finally {
        this.show_spinner = false;
      }
    },

    // Primer tramo del SSO: manda a la persona a Google pasando por el backend
    // (utils/sso/redireccion.js). Si sale bien la página se va, así que el
    // spinner se queda puesto hasta que el navegador navega.
    async iniciarSso({ proveedor }) {
      if (this.procesandoSso) return;
      this.procesandoSso = true;
      this.show_spinner = true;
      this.error_pass_mail = false;
      this.sso_error_msg = "";

      const resultado = await iniciarSsoGoogle({
        urlRegreso: new URL(
          this.$router.resolve({ name: "Login" }).href,
          window.location.origin,
        ).href,
        recordarSesion: this.recordarSesion,
      });
      if (!resultado) return;

      this.sso_error_msg = mensajeErrorSso(resultado.error, proveedor);
      this.procesandoSso = false;
      this.show_spinner = false;
    },

    // Segundo tramo: la vuelta desde el backend, ya sacada de la URL. Termina
    // el ingreso por el mismo camino que la contraseña.
    async completarRetornoSso(retorno) {
      if (!retorno || retorno.cancelado) return;
      const { proveedor, tokens } = retorno;
      if (!tokens) {
        this.sso_error_msg = mensajeErrorSso(retorno.error, proveedor);
        return;
      }

      this.procesandoSso = true;
      this.show_spinner = true;
      // Lo marcado antes de salir a Google: con la recarga se había perdido
      this.recordarSesion = retorno.recordarSesion;
      try {
        const errorSesion = await this.completarInicioSesion(tokens, {
          rechazarPrivilegio3: true,
        });
        if (errorSesion) this.sso_error_msg = errorSesion;
      } catch (e) {
        console.error(`Error en el inicio de sesión con ${proveedor}:`, e);
        this.clearSession();
        this.sso_error_msg = mensajeErrorSso(null, proveedor);
      } finally {
        this.procesandoSso = false;
        this.show_spinner = false;
      }
    },

    // Tramo común del ingreso, desde que ya hay tokens: los guarda, carga el
    // usuario y sus módulos, y navega al primer módulo disponible. Lo usan el
    // ingreso con contraseña y el SSO, para que una sesión abierta con Google
    // quede idéntica a una abierta con contraseña.
    //
    // @param {Object} tokens - access_token, user_token y uuid del backend.
    // @param {Object} opciones
    // @param {Boolean} opciones.rechazarPrivilegio3 - para el SSO por
    // redirección: el backend todavía no recibe ahí tipo_web, así que no frena
    // al privilegio 3 como sí lo hace con la contraseña. Mientras no lo haga
    // (instructivo del backend, punto 4) se frena acá, antes de guardar el usuario.
    // @returns {String|null} - null si la sesión quedó abierta. Si falta algo,
    // limpia la sesión y devuelve el mensaje a mostrar; quien llama decide
    // dónde. Un error inesperado se propaga a su try/catch.
    async completarInicioSesion(tokens, { rechazarPrivilegio3 = false } = {}) {
      localStorage.setItem("access-token", tokens.access_token);
      // Antes de cargar el usuario: App.vue revisa la sesión apenas aparece
      // y sin estos datos la daría por cerrada (ver utils/sesion.js)
      this.$ls.set("remember_session", this.recordarSesion);
      marcarSesionNavegador();

      const respUser = await this.getUserDataFromTokenAction({
        token: tokens.user_token,
        uuid: tokens.uuid,
      });

      if (!respUser || !respUser.empresa?.[0] || !respUser.privilegio?.[0]) {
        this.clearSession();
        return "No pudimos obtener tus datos de usuario. Por favor intenta nuevamente.";
      }

      if (rechazarPrivilegio3 && Number(respUser.privilegio[0].id_tipo) === 3) {
        this.clearSession();
        return mensajeErrorSso("FORBIDDEN", "Google");
      }

      await this.processUserData(respUser);

      if (this.userHasInicio) {
        this.irA({ name: "Inicio" });
        return null;
      }

      if (!this.modules.length) {
        this.clearSession();
        return "Tu usuario no tiene módulos habilitados. Por favor contacta a soporte.";
      }

      this.redirectToLoneModule(this.modules);
      return null;
    },


    async processUserData(userData) {
      this.sanitizeBackendUserData(userData);
      // Escribe en localStorage y deja el store al día de una sola vez.
      this.$store.commit("loginModule/SET_USER_DATA", userData);
      this.$ls.set("user_empresa", userData.empresa[0]);
      await this.getUserModules(
        userData.privilegio[0].id_tipo,
        userData.grupo != null &&
          typeof userData.grupo[0] === "object" &&
          userData.grupo[0] != null
          ? userData.grupo[0].id_grupo
          : "null",
      );
    },

    async getUserModules(idPrivilegio, idGrupo) {
      const data = {
        id_privilegio: idPrivilegio,
        id_grupo: idGrupo,
      };
      await this.getModules(data);
    },

    sanitizeBackendUserData(resp) {
      if (!resp) {
        // toast error..
        return;
      }
      if (
        Array.isArray(resp.cargo) &&
        resp.cargo[0] == null &&
        typeof resp.cargo[0] === "object"
      ) {
        resp.cargo[0] = {
          id_cargo: "0",
          nombre_cargo: "S/N",
        };
      }
      if (
        Array.isArray(resp.gerencia) &&
        resp.gerencia[0] == null &&
        typeof resp.gerencia[0] === "object"
      ) {
        resp.gerencia[0] = {
          id_gerencia: "0",
          nombre_gerencia: "S/N",
        };
      }
      if (
        Array.isArray(resp.grupo) &&
        resp.grupo[0] == null &&
        typeof resp.grupo[0] === "object"
      ) {
        resp.grupo[0] = {
          id_grupo: "0",
        };
      }
      if (
        Array.isArray(resp.sucursal) &&
        resp.sucursal[0] == null &&
        typeof resp.sucursal[0] === "object"
      ) {
        resp.sucursal[0] = {
          id_sucursal: "0",
          nombre_sucursal: "S/N",
        };
      }
      if (
        Array.isArray(resp.turno) &&
        resp.turno[0] == null &&
        typeof resp.turno[0] === "object"
      ) {
        resp.turno[0] = {
          id_turno: "0",
          nombre_turno: "S/N",
        };
      }
    },

    validUserEmail(email, from) {
      var regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      setTimeout(() => {
        if (String(email).toLowerCase().match(regex)) {
          if (from == "login") {
            this.icon_input_login = "check";
            this.incorrect_mail = false;
          }
          if (from == "recovery") {
            this.valid_mail = true;
            this.incorrect_mail = false;
          }
          return true;
        } else {
          if (from == "login") {
            this.icon_input_login = "error";
            this.incorrect_mail = false;
          }
          if (from == "recovery") {
            this.incorrect_mail = true;
            this.valid_mail = false;
          }
        }
      }, 1000);
    },

    validLoginInput(input) {
      if (input.length > 5 && input !== "") {
        if (input.includes("@")) {
          // si es true quiere decir que es un email
          this.login_type = "1"; // 1 para correo
          this.validUserEmail(input, "login");
        } else {
          // si es false quiere decir que es Rut
          this.login_type = "2"; // 2 para rut
          if (input.length >= 8) {
            this.icon_input_login = "check";
          } else {
            this.icon_input_login = "error";
          }
        }
      }
    },
    activeLoginBtn() {
      return this.email !== "" && this.password.length >= 4 ? true : false;
    },
  },
};
</script>

<template>
  <div class="login">
    <div class="login__content">
      <!-- Panel izquierdo: marketing -->
      <div class="login__left">
        <div class="login__logo reveal" :class="{ in: pageReady }">
          <img
            :src="publicPath + 'imgs/kaik.svg'"
            alt="Logo KAIK"
            class="login__logo-img"
            height="36"
          />
        </div>

        <div
          class="login__headline mt-3 reveal reveal-delay-1"
          :class="{ in: pageReady }"
        >
          <span class="login__headline-gray">One access.</span><br />
          <span class="login__headline-blue">Endless solutions.</span>
        </div>

        <p
          class="login__subtitle lh-90 reveal reveal-delay-2 mt-3 mb-4"
          :class="{ in: pageReady }"
        >
          Accede con una sola credencial y visualiza únicamente<br />
          los módulos contratados para tu cuenta.
        </p>

        <div
          class="login__solutions reveal reveal-delay-3"
          :class="{ in: pageReady }"
        >
          <h3 class="login__solutions-title font-accent">Soluciones</h3>
          <div class="login__solutions-grid">
            <div class="login__solution-card">
              <Favicon dosts="#e2097e" 
               />
              <span class="login__solution-label color-signage">Signage</span>
            </div>
            <div class="login__solution-card">
              <Favicon dosts="#15ac80" 
               />
              <span class="login__solution-label color-intranet"
                >Intranet+</span
              >
            </div>
            <div class="login__solution-card">
              <Favicon dosts="#664cfd" 
               />
              <span class="login__solution-label color-connect">Connect</span>
            </div>
            <div class="login__solution-card">
              <Favicon dosts="#f9b115" 
               />
              <span class="login__solution-label color-manage">Manage</span>
            </div>
          </div>
        </div>

        <p class="login__cta reveal reveal-delay-3 login__subtitle" :class="{ in: pageReady }">
          ¿Necesitas algo único para tu negocio?<br />
          <span class="color-black font-accent font-500"
            >Let's Create.
            <a href="mailto:contacto@kaik.com" class="login__cta-link font-accent font-700"
              >Contáctanos</a
            ></span
          >
        </p>
      </div>

      <!-- Panel derecho: tarjeta -->
      <div class="login__right">
        <div class="login__logo-right reveal" :class="{ in: pageReady }">
          <img
            :src="publicPath + 'imgs/kaik.svg'"
            alt="Logo KAIK"
            class="login__logo-right-img"
            height="36"
          />
        </div>

        <div
          class="login__card reveal reveal-delay-1"
          :class="{ 'login__card--recover': view === 'recover', in: pageReady }"
        >
          <!-- Vista: Login -->
          <template v-if="view === 'login'">
            <small class="login__card-label font-400">INICIA SESIÓN</small>
            <h2 class="login__card-title">¡Bienvenid@!</h2>

            <!-- Input RUT / correo -->
            <div class="login__input-wrap">
              <svg
                class="login__input-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                  stroke="var(--color-kaik)"
                  stroke-width="1.8"
                />
                <path
                  d="M3 22C3 17.0294 7.02944 13 12 13C16.9706 13 21 17.0294 21 22"
                  stroke="var(--color-kaik)"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />
              </svg>
              <input
                type="text"
                placeholder="Ingresa tu RUT o tu correo"
                v-model.trim="email"
                required
                @keydown.space.prevent
                @keypress="validLoginInput(email)"
                @keyup.delete="validLoginInput(email)"
              />
            </div>

            <!-- Input contraseña -->
            <div class="login__input-wrap">
              <svg
                class="login__input-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <rect
                  x="3"
                  y="11"
                  width="18"
                  height="11"
                  rx="2"
                  stroke="var(--color-kaik)"
                  stroke-width="1.8"
                />
                <path
                  d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                  stroke="var(--color-kaik)"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />
              </svg>
              <input
                :type="verPassword ? 'text' : 'password'"
                v-model="password"
                placeholder="Contraseña"
                @keypress.enter="logIn()"
                required
              />
              <button
                type="button"
                class="login__eye"
                @click="verPassword = !verPassword"
                :aria-label="
                  verPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
                "
              >
                <svg
                  v-if="!verPassword"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                  />
                </svg>
                <svg
                  v-else
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                  <line
                    x1="1"
                    y1="1"
                    x2="23"
                    y2="23"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>

            <!-- Recordar sesión -->
            <label
              class="login__remember d-flex justify-content-center mx-auto my-0"
            >
              <input type="checkbox" v-model="recordarSesion" />
              <span class="font-accent">Recordar sesión</span>
            </label>

            <!-- Error credenciales -->
            <div v-if="error_pass_mail" class="login__error font-accent">
              {{ login_error_msg }}
            </div>

            <!-- Botón ingresar -->
            <button
              class="btn btn-custom-color-blue border-round-50 mw-100 my-2"
              @click="logIn()"
            >
              Entrar al administrador
            </button>

            <!-- Ingreso con proveedor externo. No dibuja nada si el build
                 no trae VUE_APP_SSO_BASE_URL -->
            <BotonesSso
              :deshabilitado="procesandoSso"
              @iniciar="iniciarSso"
            />

            <div v-if="sso_error_msg" class="login__error">
              {{ sso_error_msg }}
            </div>

            <!-- Recuperar contraseña -->
            <a class="login__forgot mb-1 font-accent" @click="goToRecoverView()">
              ¿Has olvidado tu contraseña?
            </a>

            <!-- Soporte -->
            <p class="login__support ">
              ¿Necesitas ayuda?
              <a href="mailto:soporte@kaik.com" class="login__support-link font-accent" 
                >Contactar soporte</a
              >
            </p>
          </template>

          <!-- Vista: Recuperar contraseña -->
          <template v-else>
            <h2
              class="login__card-title login__card-title--recover text-center"
            >
              ¿Has olvidado tu contraseña?
            </h2>

            <p class="login__subtitle--recover text-center">
              Ingresa tu correo electrónico y te enviaremos un enlace para
              recuperar tu contraseña
            </p>

            <form
              class="login__recover-form"
              @submit.prevent="onPassRecoverySubmit"
              novalidate
            >
              <div
                class="login__input-wrap"
                :class="{ 'login__input-wrap--error': recoveryEmailError }"
              >
                <svg
                  class="login__input-icon"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                    fill="var(--color-kaik)"
                  />
                </svg>
                <input
                  id="recovery-email"
                  type="email"
                  v-model.trim="recoveryEmail"
                  placeholder="Ingresa tu correo"
                  @keydown.space.prevent
                  autocomplete="email"
                />
              </div>
              <div
                v-if="recoveryEmailError"
                class="login__error"
                style="margin-top: -8px; margin-bottom: 8px"
              >
                {{ recoveryEmailError }}
              </div>

              <p class="login__subtitle--recover text-center mt-2">
                Si no recibes el correo en los próximos
                <strong>10 minutos</strong> (recuerda revisar spam) o no tienes
                uno registrado, por favor comunícate con el
                <strong>Área de Comunicaciones</strong>.
              </p>

              <div class="d-flex justify-content-center my-2">
                <button
                  type="submit"
                  class="btn btn-custom-color-blue border-round-50 mw-100"
                >
                  Enviar
                </button>
              </div>
            </form>

            <a class="login__forgot" @click="goToLoginView()">
              Volver al inicio de sesión
            </a>

            <Spinner v-if="show_spinner_recover" />
          </template>
        </div>
        <img
          :src="publicPath + 'imgs/login/perro_volador.png'"
          alt="Mascota KAIK"
          class="login__dog"
        />
        <img
          :src="publicPath + 'imgs/login/icon_l.svg'"
          alt=""
          class="login__icon-l"
          aria-hidden="true"
        />
        <img
          :src="publicPath + 'imgs/login/icon_c.svg'"
          alt=""
          class="login__deco-c"
          aria-hidden="true"
        />

        <a
          href="https://www.linkedin.com/company/k%C3%A4ik-digital-solutions/posts/"
          class="login__deco-linkedin"
          target="_blanck"
          aria-label="LinkedIn"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z"
              fill="var(--color-kaik)"
            />
          </svg>
        </a>
      </div>
    </div>

    <Status
      v-if="recoveryStatus !== null"
      :msg="recoveryMsg"
      :status="recoveryStatus"
      @close="closeRecoveryStatus()"
      style="z-index: 100"
    />
    <!-- Footer -->
    <div class="login__footer">
      <MadeWith />
    </div>

    <Spinner v-if="show_spinner" />
  </div>
</template>
